<div class="p-4">
  <p class="text-gray-800 text-sm font-semibold mb-4">
    Configure the languages that should be available for NW Number Error Memory
  </p>
  <ul class="space-y-4 text-left text-gray-500 dark:text-gray-400">
    @for (selectedLanguage of selectedLanguages; track $index) {
      <li class="flex items-center space-x-3 rtl:space-x-reverse">
        <div class="flex items-center">
          <input
            [disabled]="noAccessToLanguageConfiguration"
            [checked]="selectedLanguage[1]"
            type="checkbox"
            value=""
            class="primary-checkbox"
            (change)="updateLanguageSelection($event, selectedLanguage[0].languageCodeId)"
          />
          <label
            [ngClass]="noAccessToLanguageConfiguration ? 'text-gray-500' : 'text-gray-800'"
            for="checked-checkbox"
            class="ms-2 text-sm font-medium"
            >{{ selectedLanguage[0].languageCodeId }}</label
          >
        </div>
      </li>
    }
  </ul>
</div>
